var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashBoardLayout',[_c('div',[_c('h3',[_vm._v("Developer Contact Page ....")])])])}
var staticRenderFns = []

export { render, staticRenderFns }